import { cn } from '../utils/functions';

import shield from '@/assets/escudo.svg';
import shieldAssets from '@/modules/edit-my-account/components/my-team/shieldAssets';
import { PropsWithClassName } from '@/types';

type ShieldProps = PropsWithClassName<{
  textContent?: string;
  style?: React.CSSProperties;
  pattern?: string;
  backgroundColor?: string;
  patternColor?: string;
  shieldBase?: string;
  shieldMask?: string;
  id?: string;
}>;

export const ShieldTeam = ({
  className,
  style,
  textContent,
  pattern,
  backgroundColor,
  patternColor,
  id,
}: ShieldProps) => {
  if (!id) {
    return (
      <svg
        className={cn(
          'lg:w-[140px] lg:h-[158px] w-[104px] h-[118px]',
          className
        )}
        xmlns="http://www.w3.org/2000/svg"
      >
        <image
          className="w-full"
          href={shield}
          overflow="visible"
          width="100%"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      style={style}
      viewBox="-109 -121 216 242"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <defs>
          <path
            d={shieldAssets.handleShieldId(id)?.shieldMask}
            id={`shield-path-${id}`}
          />
          <clipPath id={`shield-clipPath-${id}`}>
            <use xlinkHref={`#shield-path-${id}`} />
          </clipPath>
        </defs>

        <g className="escudoBase">
          <path
            d={shieldAssets.handleShieldId(id)?.shieldBase}
            fill={backgroundColor}
          />
        </g>

        <g clipPath={`url(#${`shield-clipPath-${id}`})`}>
          {pattern && shieldAssets.handleShieldId(id) && (
            <path
              className="trama"
              d={shieldAssets.handleShieldId(id)?.[`trama${pattern}`]}
              fill={patternColor}
            />
          )}
        </g>

        <text
          fill={patternColor}
          fontFamily="Bebas Neue"
          fontSize={42}
          textAnchor="middle"
          transform="matrix(1 0 0 1 0 -52.6646)"
        >
          {textContent}
        </text>
      </g>
    </svg>
  );
};
